<template>
  <div id="page-wrapper">
    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>
        <div class="main-page-content  ml-0">
          <div id="main-wrapper" class="layout-main-wrapper clearfix">
            <div id="main" class="container-fluid">
              <div class="row row-offcanvas row-offcanvas-left clearfix">
                <main class="main-content col content-full-width" id="content" role="main">
                  <section id="userlist-manager" class="section">
                    <div class="container-fluid p-0">
                      <div class="row mb-15">
                        <div id="vitamins" class="col-md-12">
                          <div class="col-card mh">
                            <user-form :userObj="user" :type="'user'"></user-form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script>

  import Header from "../Header";
  import Nav from "../Nav";
  // import axios from "../../axios-auth";
  import Userform from "../Users/Userform";
  import store from "../../store/store";

  export default {
    components: {
      userForm: Userform,
      appHeader: Header,
      appNavbar: Nav
    },
    created() {
      this.user = store.getters.getUser;
    },
    data() {
      return {
        user: null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Account/Profile.vue